
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_470_1484)","stroke":"#667080","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M10 18.333a8.333 8.333 0 100-16.666 8.333 8.333 0 000 16.666zM1.666 10h16.667"}}),_c('path',{attrs:{"d":"M10 1.667A12.75 12.75 0 0113.332 10a12.75 12.75 0 01-3.334 8.333A12.75 12.75 0 016.666 10a12.75 12.75 0 013.333-8.333v0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_470_1484"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    